import React from 'react';
import { connect } from 'react-redux';
import GeneralAggregationChart from '../../SystemDashboard/GeneralAggregationChart';
import { yaxis_count } from '../../../../../constants';
import { getColorById, getOnlyUnique, getPercentage, isDefined, getXaxisCategories, arrayIsNotEmpty } from '../../../../../utils';
import GeneralChart from "../GeneralChart.jsx";

class GeneralAggregationChartWithExternalLegendContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notVisibleAggregationName: []
        };
        this.toggleDataSeries = this.toggleDataSeries.bind(this);
        this.getValueForDate = this.getValueForDate.bind(this);
    }

    toggleDataSeries(e) {
        if (this.state.notVisibleAggregationName.includes(e.dataSeries.name)) {
            this.state.notVisibleAggregationName = this.state.notVisibleAggregationName.filter(item => item !== e.dataSeries.name);
        }
        else {
            this.state.notVisibleAggregationName.push(e.dataSeries.name);
        }

        this.setState({ reactUpdater: !this.state.reactUpdater });
    }

    getValueForDate(valueType, itemCurrentDateStats) {
        if (!isDefined(itemCurrentDateStats)) {
            return undefined;
        }
        if (valueType === "ticketCount") {
            const value = itemCurrentDateStats.tickets;
            return value;
        }
        else if (valueType === "overalSuccessRatePercent") {
            const medValue = itemCurrentDateStats.overalSuccessRatePercent;
            return medValue;
        }
        else if (valueType === "yesResponsePercentage") {
            const yesCountPercentage = getPercentage(itemCurrentDateStats.effectiveResponseCntRounded, itemCurrentDateStats.sumQuestionEffectiveResponses);
            return yesCountPercentage;
        }
    }

    render() {
        const { propId, allItemsBreakdownOverTimeStats, chartType, questionCode, valueType, maxX, suffixY, hideLegend, yAxis,
            itemIdsActiveInLegend } = this.props;

        if (!allItemsBreakdownOverTimeStats || !Array.isArray(allItemsBreakdownOverTimeStats)) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        }
        else if (allItemsBreakdownOverTimeStats.length == 0) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                No data
            </div>;
        }

        let data = [];

        let maxDateIndex = allItemsBreakdownOverTimeStats.reduce((max, obj) => {
            return obj.dateIndex > max ? obj.dateIndex : max;
        }, -Infinity);

        const responseForQuestionBreakdownOverTimeStats = allItemsBreakdownOverTimeStats.filter(r => r.questionCode === questionCode
            && itemIdsActiveInLegend.some(itemId => itemId == r.aggregationId));

        const itemsName = responseForQuestionBreakdownOverTimeStats.map(p => p.aggregationName).filter(getOnlyUnique);
        itemsName.forEach(ch => {
            let itemAllDatesData = responseForQuestionBreakdownOverTimeStats.filter(p => p.aggregationName === ch);

            if (valueType === "yesResponsePercentage") {
                itemAllDatesData = itemAllDatesData.filter(p => (p.finalResponse === 'Yes' || p.finalResponse === 'Satisfied'))
            }

            let itemDataPoints = [];
            for (var i = 1; i <= maxDateIndex; i++) {
                const elementWithCurrentDateIndex = responseForQuestionBreakdownOverTimeStats.find(cbo => cbo.dateIndex === i);
                if (isDefined(elementWithCurrentDateIndex)) {
                    const windowStart = elementWithCurrentDateIndex.windowStart;
                    if (isDefined(windowStart)) {
                        const windowStartLabel = windowStart.slice(0, 5);

                        if (this.state.notVisibleAggregationName.includes(ch)) {
                            itemDataPoints.push({
                                label: windowStartLabel,
                                y: undefined
                            });
                        }
                        else {
                            const itemCurrentDateStats = itemAllDatesData.find(cd => cd.dateIndex === i);
                            const itemCurrentDateValue = this.getValueForDate(valueType, itemCurrentDateStats);
                            itemDataPoints.push({
                                label: windowStartLabel,
                                y: itemCurrentDateValue
                            });
                        }
                    }
                }
            }

            const a = {
                type: chartType,
                name: isDefined(ch) ? ch : 'None',
                showInLegend: !hideLegend,
                yValueFormatString: "#,###",
                dataPoints: itemDataPoints,
                color: getColorById(arrayIsNotEmpty(itemAllDatesData) ? itemAllDatesData[0].aggregationId : undefined)
            };
            data.push(a);
        });

        return (
            <GeneralAggregationChart
                suffixY={suffixY}
                maxX={maxX}
                data={data}
                propId={propId}
                toggleDataSeries={this.toggleDataSeries}
            />
        );
    }
}

const select = state => ({});

export default connect(select)(GeneralAggregationChartWithExternalLegendContainer);